export const errorMessage = {
    '& div': {
        '& span': {
            color: '$errorText',
            fontSize: '$errorFontSize',
            marginLeft: '$errorTextMargin',
        },
        '& svg': {
            color: '$errorText',
            height: '1.5rem',
            position: 'absolute',
            width: '1.5rem',
        },
        'padding': '1rem',
    },
    'alignContent': 'center',
    'background': '$error',
    'borderRadius': '$errorBorder',
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'center',
    'marginBottom': '$errorMargin',
    'variants': {type: {info: {background: '$highlight'}}},
}

export const LoginRegisterTabButtonStyles = {
    background: 'transparent',
    border: 0,
    borderBottom: '1px solid $loginBorder',
    color: '$loginTabNotSelected',
    flex: 1,
    height: '2rem',
    variants: {
        selected: {
            true: {
                borderBottom: '1px solid $loginSelectedBorder',
                color: '$loginTabSelected',
                outline: 'none',
            },
        },
    },
}

export const LoginRegisterHeaderStyles = {
    '& .loginOrRegisterContainer': {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '2rem',
    },
}
